module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "practice"
    }
  }, [(false) ? _c('div', {
    staticClass: "mb-3 text-sm-right"
  }, _vm._l(([5, 4, 2, 1, 3]), function(n) {
    return _c('span', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (_vm.typeList.indexOf(n) > -1),
        expression: "typeList.indexOf(n) > -1"
      }],
      key: n,
      staticClass: "btn btn-primary ml-3",
      class: {
        'active': _vm.type === n
      },
      on: {
        "click": function($event) {
          _vm.type = n
        }
      }
    }, [_vm._v(" " + _vm._s(_vm.typeName(n)) + "\n    ")])
  }), 0) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "font-size-control questions"
  }, [_vm._l((_vm.questions), function(row, qindex) {
    return (_vm.current === qindex) ? _c('div', {
      key: qindex,
      staticClass: "card"
    }, [_c('div', {
      staticClass: "card-header text-sm-right"
    }, [_vm._v("\n        " + _vm._s(_vm.typeName(row.practiceType)) + " " + _vm._s((qindex + 1)) + " / " + _vm._s(_vm.questions.length) + "\n      ")]), _vm._v(" "), _c('div', {
      staticClass: "card-block fixed-height text-left p-3"
    }, [_c('span', {
      staticClass: "number"
    }, [_vm._v(_vm._s(('0' + (qindex + 1)).slice(-2)) + ". ")]), _vm._v(" "), (row.audio) ? _c('span', {
      staticClass: "btn",
      on: {
        "click": function($event) {
          _vm.playAudioFile(row.audio)
        }
      }
    }, [_c('i', {
      staticClass: "fas fa-volume-up",
      attrs: {
        "aria-label": "audio"
      }
    })]) : _vm._e(), _vm._v(" "), (row.practiceType === 4 || row.practiceType === 1) ? _c('div', [(row.practiceType === 1) ? _c('p', [_vm._v(_vm._s(row.title_i18N[0].value))]) : _vm._e(), _vm._v(" "), _vm._l((row.titleFields), function(option, optionIndex) {
      return _c('span', {
        key: optionIndex
      }, [(row.answers.indexOf(option.value) > -1) ? _c('input', {
        directives: [{
          name: "model",
          rawName: "v-model",
          value: (row.useranswer[option.index]),
          expression: "row.useranswer[option.index]"
        }],
        class: {
          'wrong': _vm.checkAnswer && row.useranswer[option.index] !== row.answers[option.index]
        },
        attrs: {
          "type": "text",
          "disabled": _vm.retryTimes === 0
        },
        domProps: {
          "value": (row.useranswer[option.index])
        },
        on: {
          "focus": function($event) {
            _vm.resetCheck()
          },
          "input": function($event) {
            if ($event.target.composing) { return; }
            _vm.$set(row.useranswer, option.index, $event.target.value)
          }
        }
      }) : _c('span', {
        domProps: {
          "innerHTML": _vm._s(option.value)
        }
      })])
    })], 2) : _vm._e(), _vm._v(" "), (row.practiceType === 2 || row.practiceType === 5) ? _c('div', [_c('p', {
      domProps: {
        "innerHTML": _vm._s(row.title)
      }
    }), _vm._v(" "), _vm._l((row.items), function(item, index) {
      return _c('p', {
        key: index,
        class: {
          'wrong': _vm.checkAnswer && row.useranswer[0] === _vm.fromCharCode(index) && row.useranswer[0].toLowerCase() !== row.answers[0].toLowerCase()
        }
      }, [_c('input', {
        directives: [{
          name: "model",
          rawName: "v-model",
          value: (row.useranswer[0]),
          expression: "row.useranswer[0]"
        }],
        attrs: {
          "type": "radio",
          "disabled": _vm.retryTimes === 0
        },
        domProps: {
          "value": _vm.fromCharCode(index),
          "checked": _vm._q(row.useranswer[0], _vm.fromCharCode(index))
        },
        on: {
          "focus": function($event) {
            _vm.resetCheck()
          },
          "change": function($event) {
            _vm.$set(row.useranswer, 0, _vm.fromCharCode(index))
          }
        }
      }), _vm._v(" "), _c('button', {
        staticClass: "btn btn-text",
        attrs: {
          "disabled": _vm.retryTimes === 0
        },
        domProps: {
          "innerHTML": _vm._s(item)
        },
        on: {
          "click": function($event) {
            _vm.selectRadio(qindex, index)
          }
        }
      })])
    })], 2) : _vm._e(), _vm._v(" "), (row.practiceType === 3) ? _c('div', [_c('p', [_vm._v(_vm._s(row.title_i18N[0].value))]), _vm._v(" "), _vm._l((row.questions), function(option, optionIndex) {
      return _c('span', {
        directives: [{
          name: "show",
          rawName: "v-show",
          value: (row.useranswer_tmp.indexOf(option) === -1),
          expression: "row.useranswer_tmp.indexOf(option) === -1"
        }],
        key: optionIndex,
        staticClass: "questBox",
        style: ({
          'padding-top': (_vm.lang === 'Ja') ? '1.3em' : '0.3em'
        }),
        domProps: {
          "innerHTML": _vm._s(option)
        },
        on: {
          "click": function($event) {
            _vm.resetCheck() && row.useranswer_tmp.push(option) && (row.useranswer[0] = row.useranswer_tmp.join(' '))
          }
        }
      })
    }), _vm._v(" "), _c('div', {
      staticClass: "answerPool",
      class: {
        'wrong': _vm.checkAnswer && !_vm.isCorrect
      },
      on: {
        "blur": function($event) {
          (_vm.checkAnswer === true) ? _vm.checkAnswer = false: _vm.checkAnswer = _vm.checkAnswer
        }
      }
    }, _vm._l((row.useranswer_tmp), function(option, optionIndex) {
      return _c('span', {
        key: optionIndex,
        domProps: {
          "innerHTML": _vm._s(option)
        },
        on: {
          "click": function($event) {
            _vm.resetCheck() && row.useranswer_tmp.splice(row.useranswer_tmp.indexOf(option), 1)
          }
        }
      })
    }), 0)], 2) : _vm._e(), _vm._v(" "), (_vm.checkAnswer && _vm.retryTimes === 0 || _vm.isCorrect) ? _c('div', {
      staticClass: "answer"
    }, [_vm._v("Answer：\n          "), _vm._l((row.answers), function(answer, ans_index) {
      return _c('span', {
        key: ans_index,
        domProps: {
          "innerHTML": _vm._s(ans_index > 0 ? ', ' + answer : answer)
        }
      })
    })], 2) : _vm._e(), _vm._v(" "), (_vm.checkAnswer && _vm.retryTimes < 2) ? _c('div', {
      staticClass: "mt-3",
      class: {
        'right': _vm.isCorrect, 'wrong': !_vm.isCorrect
      }
    }, [_vm._v("\n          " + _vm._s(_vm.isCorrect ? '答案正確' : '答案錯誤') + "\n        ")]) : _vm._e()])]) : _vm._e()
  }), _vm._v(" "), (_vm.current === -1) ? _c('div', {
    staticClass: "card"
  }, [_c('div', {
    staticClass: "card-block fixed-height p-4"
  }, [_vm._v("\n        您的課後測驗結果為：\n\n        "), _c('span', {
    class: {
      'right': _vm.score >= _vm.passRate,
        'wrong': _vm.score < _vm.passRate,
    }
  }, [_vm._v(_vm._s((_vm.score >= _vm.passRate) ? '通過' : '未通過'))]), _vm._v(" "), _c('div', {
    staticClass: "text-center mt-5 mb-5"
  }, [_vm._v("\n          答對率\n          "), _c('span', {
    class: {
      'right': _vm.score >= _vm.passRate,
        'wrong': _vm.score < _vm.passRate,
    },
    staticStyle: {
      "font-size": "5em"
    }
  }, [_vm._v(_vm._s(_vm.score) + "%")])])])]) : _vm._e()], 2), _vm._v(" "), _c('div', {
    staticClass: "mt-2 text-right"
  }, [_c('span', {
    staticClass: "float-left mr-3"
  }, [_vm._t("left")], 2), _vm._v(" "), (_vm.current === -1) ? _c('span', {
    staticClass: "btn btn-danger float-left",
    on: {
      "click": function($event) {
        _vm.current = 0
      }
    }
  }, [_vm._v("重新開始")]) : _vm._e(), _vm._v(" "), (_vm.current >= 0 && _vm.current <= (_vm.questions.length - 1) && !_vm.isAllowToNext) ? _c('span', {
    staticClass: "btn btn-warning",
    on: {
      "click": function($event) {
        _vm.checkAnswers()
      }
    }
  }, [_vm._v("送出答案")]) : _vm._e(), _vm._v(" "), (_vm.current >= 0 && _vm.current < (_vm.questions.length - 1) && _vm.isAllowToNext) ? _c('span', {
    staticClass: "btn btn-primary",
    on: {
      "click": function($event) {
        _vm.current += 1
      }
    }
  }, [_vm._v("下一題")]) : _vm._e(), _vm._v(" "), (_vm.current >= (_vm.questions.length - 1) && _vm.isAllowToNext) ? _c('span', {
    staticClass: "btn btn-warning",
    on: {
      "click": function($event) {
        _vm.current = -1
      }
    }
  }, [_vm._v("完成考試")]) : _vm._e(), _vm._v(" "), (_vm.isWriting && _vm.current >= (_vm.questions.length - 1) && _vm.isAllowToNext) ? _c('span', {
    staticClass: "btn btn-danger",
    on: {
      "click": function($event) {
        _vm.goToWriting()
      }
    }
  }, [_vm._v("前往寫作課程")]) : _vm._e()])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-5d4a9dc8!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/live-player/components/Practice.vue
// module id = 731
// module chunks = 1